import { Icono } from './Icono';

export function Pasos({ pasos, actual }: { pasos: readonly string[]; actual: number }) {
  return (
    <ol className="pasos">
      {pasos.map((texto, i) => {
        const estado = i < actual ? 'hecho' : i === actual ? 'actual' : 'pendiente';
        return (
          <li key={texto} className={`pasos__paso pasos__paso--${estado}`} aria-current={i === actual ? 'step' : undefined}>
            <span className="pasos__numero">
              {estado === 'hecho' ? <Icono nombre="check" tamano={14} grosor={3} /> : i + 1}
            </span>
            <span className="pasos__texto">{texto}</span>
          </li>
        );
      })}
    </ol>
  );
}
